module.exports = __webpack_public_path__ + "assets/img/00016.06e17cbf.png";